// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SyncAllModal_calendarSyncLabel__vJrsm {
  font: var(--body-font-three) !important;
  color: var(--secondary-Text) !important;
  text-align: center !important;
}

.SyncAllModal_calendarSyncAllIcon__xAvSH {
  background-color: #D6E3EB !important;
}

.SyncAllModal_calendarSyncAllSubHeading__fCOfU {
  color: var(--secondary-Text) !important;
}

.SyncAllModal_calendarSyncAllFooter__SXPx2 {
  justify-content: center !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/SyncAllModal.module.scss"],"names":[],"mappings":"AAAA;EACC,uCAAA;EACA,uCAAA;EACA,6BAAA;AACD;;AAEA;EACC,oCAAA;AACD;;AAEA;EACC,uCAAA;AACD;;AAEA;EACI,kCAAA;AACJ","sourcesContent":[".calendarSyncLabel {\r\n\tfont: var(--body-font-three) !important;\r\n\tcolor: var(--secondary-Text) !important;\r\n\ttext-align: center !important;\r\n}\r\n\r\n.calendarSyncAllIcon {\r\n\tbackground-color: #D6E3EB !important;\r\n}\r\n\r\n.calendarSyncAllSubHeading {\r\n\tcolor: var(--secondary-Text) !important;\r\n}\r\n\r\n.calendarSyncAllFooter {\r\n    justify-content: center !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendarSyncLabel": `SyncAllModal_calendarSyncLabel__vJrsm`,
	"calendarSyncAllIcon": `SyncAllModal_calendarSyncAllIcon__xAvSH`,
	"calendarSyncAllSubHeading": `SyncAllModal_calendarSyncAllSubHeading__fCOfU`,
	"calendarSyncAllFooter": `SyncAllModal_calendarSyncAllFooter__SXPx2`
};
export default ___CSS_LOADER_EXPORT___;
